import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // snow theme
import Quill from "quill";

const Embed = Quill.import("blots/embed");

class InsertedVariable extends Embed {
  static create(value) {
    const node = super.create();
    node.setAttribute("class", "inserted-value");
    node.innerHTML += value;
    return node;
  }
}

InsertedVariable.blotName = "inserted-value";
InsertedVariable.className = "inserted-value";
InsertedVariable.tagName = "span";

Quill.register(InsertedVariable);

export const DEFAULT_TOOLBAR_OPTIONS = [
  ["bold", "italic", "underline"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"]
];
export const MICROSITE_PAGE_TOOLBAR_OPTIONS = [
  ["bold", "italic", "underline"],
  [{ color: [] }, { size: [] }, { header: 1 }, { header: 2 }],
  [
    { list: "ordered" },
    { list: "bullet" },
    { indent: "-1" },
    { indent: "+1" },
    { align: [] }
  ],
  ["link", "image"]
];

Vue.use(VueQuillEditor, {
  modules: {
    toolbar: DEFAULT_TOOLBAR_OPTIONS
  },
  placeholder: ""
});

export default VueQuillEditor;
